<template>
  <ci-modal>
    <ci-modal-header>
      Bild löschen
    </ci-modal-header>
    <ci-modal-body>
      Möchten Sie das Bild wirklich löschen?
    </ci-modal-body>
    <ci-modal-footer>
      <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="onClose">Schließen</button>
      <button type="button" class="btn btn-danger" @click="onDelete">Löschen</button>
    </ci-modal-footer>
  </ci-modal>
</template>

<script>
// components
import Modal from '@/components/Modal.vue';
import ModalBody from '@/components/ModalBody.vue';
import ModalHeader from '@/components/ModalHeader.vue';
import ModalFooter from '@/components/ModalFooter.vue';

export default {
  name: 'ModalImageDelete',

  components: {
    'ci-modal': Modal,
    'ci-modal-body': ModalBody,
    'ci-modal-footer': ModalFooter,
    'ci-modal-header': ModalHeader,
  },

  methods: {
    onClose() {
      this.$emit('modal-image-delete:close');
    },

    onDelete() {
      this.$emit('modal-image-delete:delete');
    },
  },
};
</script>
